import { Trans } from "@web-monorepo/i18n/macro";
import { LoadingMojo } from "@web-monorepo/molecules";
import { useEffect, useState } from "react";
import styles from "./OverlayError.module.css";

// Shows the spinner immediately and reveals the error message after 3s — the
// delay gives short-lived loads a chance to finish without flashing an error.
const ERROR_REVEAL_DELAY_MS = 3000;

export default function OverlayError() {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowError(true), ERROR_REVEAL_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles.overlay}>
      <div>
        <LoadingMojo border={true} inline={true} />
        <div className={styles.message}>
          {showError && (
            <p>
              <Trans>Oops! Please refresh the screen and try your action again.</Trans>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
